import { toCanvas } from 'html-to-image';

/** 15 cm × 10 cm (paisagem) a 300 DPI */
export const INVOICE_LABEL_EXPORT_WIDTH_PX = Math.round((15 / 2.54) * 300);
export const INVOICE_LABEL_EXPORT_HEIGHT_PX = Math.round((10 / 2.54) * 300);

/**
 * Captura um nó .inv-label-paper como PNG (15×10 cm a 300 DPI).
 */
export async function exportInvoiceLabelPaperToPng(node, fileBasename = 'invoice-etiqueta') {
  if (!node) {
    throw new Error('Etiqueta não encontrada para exportar.');
  }
  node.classList.add('inv-label-paper--export');
  try {
    await new Promise((resolve) => {
      requestAnimationFrame(() => requestAnimationFrame(resolve));
    });

    const w = node.offsetWidth;
    const h = node.offsetHeight;
    if (!w || !h) {
      throw new Error('Não foi possível medir a etiqueta para exportar.');
    }
    const pixelRatio = Math.max(
      INVOICE_LABEL_EXPORT_WIDTH_PX / w,
      INVOICE_LABEL_EXPORT_HEIGHT_PX / h
    );

    const sourceCanvas = await toCanvas(node, {
      width: w,
      height: h,
      canvasWidth: w,
      canvasHeight: h,
      pixelRatio,
      backgroundColor: '#fafafa',
      cacheBust: true,
      skipAutoScale: true
    });

    const out = document.createElement('canvas');
    out.width = INVOICE_LABEL_EXPORT_WIDTH_PX;
    out.height = INVOICE_LABEL_EXPORT_HEIGHT_PX;
    const ctx = out.getContext('2d');
    if (!ctx) {
      throw new Error('Não foi possível criar o contexto da imagem.');
    }
    ctx.fillStyle = '#fafafa';
    ctx.fillRect(0, 0, out.width, out.height);
    const sw = sourceCanvas.width;
    const sh = sourceCanvas.height;
    const dw = INVOICE_LABEL_EXPORT_WIDTH_PX;
    const dh = INVOICE_LABEL_EXPORT_HEIGHT_PX;
    const almostSameSize =
      Math.abs(sw - dw) <= 2 && Math.abs(sh - dh) <= 2;
    ctx.imageSmoothingEnabled = !almostSameSize;
    if (ctx.imageSmoothingEnabled) {
      ctx.imageSmoothingQuality = 'high';
    }
    ctx.drawImage(sourceCanvas, 0, 0, sw, sh, 0, 0, dw, dh);

    const dataUrl = out.toDataURL('image/png');
    const link = document.createElement('a');
    const name = String(fileBasename).replace(/[^\w-]/g, '_') || 'invoice-etiqueta';
    link.download = `etiqueta-invoice-${name}.png`;
    link.href = dataUrl;
    link.click();
  } finally {
    node.classList.remove('inv-label-paper--export');
  }
}
